import React, { PureComponent } from "react";

class Header extends PureComponent {
  render() {
    return <h1 className="f1">RoboFriends</h1>;
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js